import { render, staticRenderFns } from "./Team_New.vue?vue&type=template&id=4d5d9291&scoped=true"
import script from "./Team_New.vue?vue&type=script&lang=js"
export * from "./Team_New.vue?vue&type=script&lang=js"
import style0 from "./Team_New.vue?vue&type=style&index=0&id=4d5d9291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d9291",
  null
  
)

export default component.exports